module.exports = __webpack_public_path__ + "img/KK0042C-IL.3c703d12.jpg";